<template>
    <Breadcrumbs main="Interview Questions" title="Interview Questions" />
    <div class="container-fluid">
        <div class="email-wrap">
            <div class="row">
                <interview-question-main />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const InterviewQuestionMain = defineAsyncComponent(() => import("@/components/interview-questions/interview-question-main.vue"))
</script>   